const DateInput = ({ id, text, value, onChange }) => {
  return (
    <div>
      <label htmlFor={id} className="block text-gray-800">{text}</label>
      <input
        type="date"
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        className="border px-2 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
      />
    </div>
  );
};

export default DateInput;
